window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-key-facts').forEach(facts => {
    const button = facts.querySelector('.product-key-facts-more');

    if (button) {
      button.addEventListener('click', e => {
        e.preventDefault();

        button.remove();

        facts.querySelectorAll('.product-key-facts-item-more').forEach(item => {
          item.classList.remove('product-key-facts-item-more');
        });
      });
    }
  });
});